import React, { useRef, useCallback, useEffect, memo } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ignoreFeedback } from '@api/feedback';

import Alert from 'components/Dialog/Alert';
import Icon from 'components/Icon';

import { BackButton } from './style';

import Statistic from './Statistic';
import Form from './Form';

const STATISTIC = 'statistic';
const FORM = 'form';

const componentList = {
	[STATISTIC]: Statistic,
	[FORM]: Form,
};

const FeedbackModal = ({
	calculateHeight = () => {},
	// closeModal,
	location,
	history,
	match: { params },
}) => {
	const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
	const alertRef = useRef();

	const invoiceId = parseInt(params?.invoiceId || 0, 10);
	const stepUrl = params?.step;
	const url = `/feedback/${invoiceId}`;

	// manage step by url
	const step = useRef();
	if (stepUrl && !step.current) {
		history.replace({ ...location, pathname: url });
	} else {
		step.current = stepUrl || FORM;
	}

	useEffect(() => {
		return () => {
			ignoreFeedback(invoiceId);
		};
	}, []);

	const goStatistic = useCallback(() => {
		history.push({
			...location,
			pathname: `${url}/${STATISTIC}`,
		});
	}, []);

	const onBack = useCallback(() => {
		history.push({
			...location,
			pathname: url,
		});
	}, []);

	if (!isLoggedIn) {
		return <Redirect to='/' />;
	}

	const Component = componentList[step.current] || componentList[FORM];
	return (
		<>
			{step.current === STATISTIC && (
				<BackButton onClick={onBack}>
					<Icon name='angle-right' />
				</BackButton>
			)}

			<Component
				goStatistic={goStatistic}
				onBack={onBack}
				invoiceId={invoiceId}
				calculateHeight={calculateHeight}
			/>

			<Alert ref={alertRef} />
		</>
	);
};

const areEqual = (prev, next) =>
	prev.location.pathname === next.location.pathname;

export default withRouter(memo(FeedbackModal, areEqual));
